import React, { Component } from 'react'

import '../styles/Button.css'

class Button extends Component {
  render () {
    const {
      label,
      icon
    } = this.props

    return (
      <div
        onClick={this.onClickHandler}
        className='Button'>
        {icon} {label}
      </div>
    )
  }

  onClickHandler = () => {
    this.props.history.push(this.props.path)
  }
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button.js